<template>
    <v-form ref="enterPasswordResetCodeForm" v-model="valid" lazy-validation>
        <div class="enter-password-reset-code__instructions">
            <div class="enter-password-reset-code__instructions-message">{{loginConstants.ENTER_CODE}}</div>
        </div>
        <v-text-field
                    id="password_reset_code"
                    name="Code"
                    v-model="code"
                    :disabled="isSubmitting"
                    required
                    data-qe-id="login_password-reset_code_input"
                    v-on:keydown.enter.prevent >
            </v-text-field>
        <v-btn id="resend_btn"
                @click="resend"
                data-qe-id="login_password-reset_resend_btn"
                :disabled="isSubmitting"
                color="ypo_blue"
                flat>
            <v-icon color="ypo_blue_secondary" left>replay</v-icon>
            {{loginConstants.RESEND}} {{loginConstants.CODE}}
        </v-btn>
        <Login-error class="enter-password-reset-code__error"></Login-error>
        <v-card-actions>
            <v-layout row wrap>
                <v-btn large flat
                       id="return_to_home_btn"
                       data-qe-id="return_to_home_btn"
                       block
                       @click="returnToLogin()">
                    {{loginConstants.CANCEL}}
                </v-btn>
                <v-btn id="continue_to_password_reset_btn"
                       color="ypo_blue"
                       class="white--text"
                       data-qe-id="login_password-reset_submit_btn"
                       @click="submit"
                       large
                       block
                       :disabled="!code.length || !valid || isSubmitting">
                    {{loginConstants.SUBMIT}}
                </v-btn>
            </v-layout>
        </v-card-actions>
    </v-form>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { storeAction } from "../../../store/storeActions.constant";
    import { loginConstants } from '../login.constants';
    import LoginError from '../LoginError';

    export default {
        name: 'EnterPasswordResetCode',
        components: { LoginError },
        data: () => ({
            loginConstants,
            valid: true,
            componentNames: loginConstants.componentNames,
            code: '',
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
        methods: {
            ...mapActions({
                submitSelectTypePasswordDelivery: `auth/${storeAction.submitSelectTypePasswordDelivery}`,
                submitRecoveryToken: `auth/${storeAction.submitRecoveryToken}`,
                submitRecoverySmsCode: `auth/${storeAction.submitRecoverySmsCode}`,
                answerSecurityQuestion: `auth/${storeAction.answerSecurityQuestion}`,
            }),
            submit() {
                this.toggleProgressIndicator();

                if (this.selectedPasswordDelivery.recoveryCodeType === 'sms') {
                    this.submitRecoverySmsCode(this.code)
                    .then(() => {
                        this.answerSecurityQuestion()
                            .then(() => {
                                this.toggleProgressIndicator();
                                this.changeCardState(this.componentNames.resetPassword.component);
                            })
                            .catch(() => {
                                this.toggleProgressIndicator();
                            });
                    })
                    .catch(() => {
                        //TODO: handle the error
                        this.toggleProgressIndicator();
                    });
                } else if (this.selectedPasswordDelivery.recoveryCodeType === 'email') {
                    this.submitRecoveryToken(this.code)
                    .then(() => {
                        this.answerSecurityQuestion()
                            .then(() => {
                                this.toggleProgressIndicator();
                                this.changeCardState(this.componentNames.resetPassword.component);
                            })
                            .catch(() => {
                                this.toggleProgressIndicator();
                            });
                    })
                    .catch(() => {
                        //TODO: handle the error
                        this.toggleProgressIndicator();
                    });
                }
            },
            resend() {
                this.toggleProgressIndicator();

                this.submitSelectTypePasswordDelivery(this.selectedPasswordDelivery)
                    .finally(() => {
                        this.toggleProgressIndicator();
                    });
            },
        },
        computed: {
            ...mapGetters({
                selectedPasswordDelivery: `auth/${storeGetters.getSelectTypePasswordDelivery}`,
            }),
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .enter-password-reset-code {
        &__title {
            padding: 5px 10px 20px 5px;
            font-size: 16px;
            color: $ypo-blue;
        }

        &__instructions {
            padding: 10px 10px 0px 5px;
            font-size: 16px;
             }

        &__error {
            padding: 0 5px 10px;
        }

        &__resend {
            color: $ypo-blue-secondary;
        }
    }
    .v-btn__content{
        @include breakpoint(xs) {
            font-size: 12px !important;
        }
    }

    .v-card__actions {
        padding-right: 0 !important;
        @include breakpoint(xs) {
            padding: 0 !important;
        }
    }

</style>
